export default __webpack_public_path__ + "static/media/LocationIcon.8a3d4ab5.svg";